// Issue log enums (API values)
export const ISSUE_SEVERITY = {
  CRITICAL: "CRITICAL",
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
};
export const ISSUE_STATUS = {
  OPEN: "OPEN",
  IN_PROGRESS: "IN_PROGRESS",
  DONE: "DONE",
  RESOLVED: "RESOLVED",
};
export const ISSUE_SOURCE_TYPE = {
  DAILY_UPDATE: "DAILY_UPDATE",
  INSPECTION: "INSPECTION",
  SITE_VISIT: "SITE_VISIT",
  CUSTOMER: "CUSTOMER",
};

/** Format enum for UI: replace _ with space and capitalize words (e.g. DAILY_UPDATE → Daily Update) */
export function formatEnumForDisplay(value) {
  if (value == null || value === "") return "";
  const str = String(value);
  return str
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Safely extract markup count from issue metadata (string or object). Returns number or undefined. */
export function getMarkupFromMetadata(metadata) {
  if (metadata == null) return undefined;
  try {
    const meta = typeof metadata === "string" ? JSON.parse(metadata) : metadata;
    if (meta && typeof meta.markup === "number") return meta.markup;
    return undefined;
  } catch {
    return undefined;
  }
}

export const getStatusStyles = (status) => {
  const s = (status || "").toLowerCase().replace(/\s+/g, "_");
  const normalized = s === "in_progress" ? "in progress" : s.replace(/_/g, " ");
  if (normalized === "open") return "bg-red-500/10 text-red-600 border-red-500/20";
  if (normalized === "in progress") return "bg-orange-500/10 text-orange-600 border-orange-500/20";
  if (normalized === "resolved" || normalized === "done") return "bg-green-500/10 text-green-600 border-green-500/20";
  return "bg-gray-100 text-gray-700 border-gray-200";
};

export const getPriorityStyles = (priority) => {
  const p = (priority || "").toLowerCase();
  if (p === "critical") return "bg-red-500/10 text-red-600";
  if (p === "high") return "bg-orange-500/10 text-orange-600";
  if (p === "medium") return "bg-amber-500/10 text-amber-600";
  return "bg-gray-100 text-gray-600";
};

/** Inline styles for pills (no Tailwind). Status pill. */
export const getStatusPillStyle = (status) => {
  const s = (status || "").toLowerCase().replace(/\s+/g, "_");
  const n = s === "in_progress" ? "in progress" : s.replace(/_/g, " ");
  if (n === "open") return { backgroundColor: "rgba(239,68,68,0.1)", color: "#b91c1c", border: "1px solid rgba(239,68,68,0.2)" };
  if (n === "in progress") return { backgroundColor: "rgba(249,115,22,0.1)", color: "#c2410c", border: "1px solid rgba(249,115,22,0.2)" };
  if (n === "resolved" || n === "done") return { backgroundColor: "rgba(34,197,94,0.1)", color: "#15803d", border: "1px solid rgba(34,197,94,0.2)" };
  return { backgroundColor: "#f3f4f6", color: "#374151", border: "1px solid #e5e7eb" };
};

/** Inline styles for pills. Severity pill. */
export const getPriorityPillStyle = (priority) => {
  const p = (priority || "").toLowerCase();
  if (p === "critical") return { backgroundColor: "rgba(239,68,68,0.1)", color: "#b91c1c" };
  if (p === "high") return { backgroundColor: "rgba(249,115,22,0.1)", color: "#c2410c" };
  if (p === "medium") return { backgroundColor: "rgba(245,158,11,0.1)", color: "#b45309" };
  if (p === "low") return { backgroundColor: "rgba(34,197,94,0.1)", color: "#15803d" };
  return { backgroundColor: "#f3f4f6", color: "#4b5563" };
};

/** Inline style for source type pill (e.g. Daily Update). */
export const getSourceTypePillStyle = () => ({
  backgroundColor: "rgba(14,165,233,0.1)",
  color: "#0369a1",
  border: "1px solid rgba(14,165,233,0.2)",
});
